import React from "react"

// import Video from "./_base/Video"

import WPImage, { DISPLAY_MODE } from "./_base/WPImage"

import { ChildSelector } from "../helpers/ChildSelector"

import * as alumniSection from "../styles/AlumniSection.module.css"

const promotionalVideo = content => {
  const videoNodes = content.childNodes.filter(node =>
    node.classNames.trim().split(/\s+/).includes("cw-external-video")
  )
  if (!videoNodes) return null

  const videoNode = videoNodes[0]
  if (!videoNode) return null

  if (!videoNode.childNodes || !videoNode.childNodes[0]) return null

  const videoLink =
    (videoNode.childNodes[0].attrs && videoNode.childNodes[0].attrs.href) ||
    null

  return videoLink
}

export default function AlumniSection(props) {
  const { content } = props

  const title = ChildSelector.select(
    content,
    `alumni-title`,
    ChildSelector.SELECTOR_TYPE.TEXT
  )

  const textStack = content.childNodes
    .filter(node =>
      node.classNames.trim().split(/\s+/).includes("alumni-content")
    )
    .map(t => t.text)

  // const videoLink = promotionalVideo(content)

  return (
    <>
      <div className={`row  ${props.className} ${alumniSection.wrapper}`}>
        <div className={`col-12 ${alumniSection.alumni}`}>
          <h1 className={`${alumniSection.title}`}>{title}</h1>
        </div>
        <div className={`row ${alumniSection.contentWrapper}`}>
          <div className={`col-5 ${alumniSection.media}`}>
            <WPImage
              holder={content}
              selector={`alumni-avatar`}
              mode={DISPLAY_MODE.normal}
              className={`col-12 ${alumniSection.mediaAvatar}`}
            />
            {/* {videoLink && <Video videoSrcURL={videoLink} videoTitle={title} />} */}
          </div>
          <div className={`col-6 ${alumniSection.testemonial}`}>
            <span className={`${alumniSection.content}`}>
              {textStack.map((segment, indx) => (
                <p key={indx}>{segment}</p>
              ))}
            </span>
          </div>
        </div>
      </div>
    </>
  )
}
